export const UPDATE_FUNDS_DATA = 'funds/UPDATE_FUNDS_DATA';